import { Chip, Grid, Paper, Stack, Typography } from "@mui/material";
import { IOcupacao } from "../../../../../../../application/models";
// Icon
import WorkIcon from '@mui/icons-material/Work'

export const RecorteCBOFilterPreview = (props: {
    cboFilter?: IOcupacao[]
}) => {

    return (
        <Grid item container xs={6} spacing={2} mb={2} p={2}>
            <Paper elevation={3} sx={{ padding: 2, width: '100%' }}>
                <Grid item xs={12} container justifyContent={'space-between'} alignItems="center" my={1}>
                    <Grid item>
                        <Typography
                            variant="body1"
                            color="primary"
                            fontWeight="bold"
                            textTransform="uppercase"
                            mr={2}
                        >
                            CBO
                        </Typography>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Stack
                        direction="row"
                        flexWrap="wrap"
                    >
                        {props.cboFilter && props.cboFilter.map((cbo, i) => (
                            <Chip
                                key={i}
                                icon={<WorkIcon />}
                                label={`${cbo.cbocodigo} - ${cbo.cbodescricao}`}
                                sx={{
                                    m: 0.5
                                }}
                            />
                        ))}
                    </Stack>
                </Grid>
            </Paper>
        </Grid>
    )
}